export const OTHER_FLAG = 'Other'
